import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { resolveLoyaltyCreditCardFeatureFlag } from 'loyalty/lib/loyaltyCreditCard/resolveLoyaltyCreditCardFeatureFlag'
import { useAppSelector } from 'hooks/reduxHooks'
import { selectLoggedIn } from 'selectors/accountSelectors'

export function useLoyaltyCreditCardFeatureFlag() {
  const flag = useLabFeatureFlag(LabFeatureFlags.societeCreditCardFlag)
  const currentRegionCode = useAppSelector(state => state.geo.currentRegionCode)
  const isLoggedIn = useAppSelector(selectLoggedIn)

  return useMemo(
    () => resolveLoyaltyCreditCardFeatureFlag(flag, currentRegionCode, isLoggedIn),
    [flag, currentRegionCode, isLoggedIn],
  )
}
